
<template>
    <div class="main-layout2" ref="mainLayout">
        <nav>
            <div class="Logo-header flx">
                <div class="left">
                    <span class="name">牦牛酪蛋白数智孪生工厂系统后台</span>
                </div>
                <div class="menu">
                    <div class="item" :class="menuId == menu.id?'active':''" v-for="(menu,index) in menuList" :key="index" @click="clickMenu(menu)">
                        <span>{{menu.name}}</span>
                    </div>
                </div>
                <div class="right flx-lc">
                    <span class="user"><i></i>管理员</span>
                    <a class="link" @click="exitLogin">退出</a>
                </div>
            </div>
            <div class="submenu" v-if="subMenu.length">
                <div class="item" :class="subMenuId == menu.id?'active':''" v-for="(menu,index) in subMenu" :key="index"><span @click="clickSubMenu(menu)">{{menu.name}}</span></div>
            </div>
        </nav>
        <article ref="article">
            <!-- 内容区 -->
            <keep-alive>
                <div class="article_content">
                    <router-view :key="$route.fullPath"></router-view>
                </div>
            </keep-alive>
        </article>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                menuId: 1,
                subMenuId: 0,
                menuList: [{
                        id: 1,
                        name:'首页',
                        path: '/admin/index',
                        children: [{
                            id: 1,
                            name: '生产安全',
                        },{
                            id: 2,
                            name: '机器狗巡检',
                        },{
                            id: 3,
                            name: '工艺流程',
                        },{
                            id: 4,
                            name: '生产数字日志',
                        },{
                            id: 5,
                            name: 'VR链接',
                        },{
                            id: 6,
                            name: '岗位员工',
                        },{
                            id: 7,
                            name: '集团介绍',
                        }]
                    },{
                        id: 2,
                        name:'虚拟工厂',
                        path: '/admin/xl',
                        children: [{
                            id: 1,
                            name: '工厂总览',
                        },{
                            id: 2,
                            name: '二号工厂',
                        },{
                            id: 3,
                            name: '设备模型详情',
                        }]
                    },{
                        id: 3,
                        name:'物理工厂',
                        path: '/admin/wl',
                        children: [{
                            id: 1,
                            name: '工厂总览',
                        },{
                            id: 2,
                            name: '科技小院',
                        },{
                            id: 3,
                            name: '二号工厂',
                        },{
                            id: 4,
                            name: '一号工厂',
                        },{
                            id: 5,
                            name: '动力车间',
                        },{
                            id: 6,
                            name: '数字赋能中心',
                        }]
                    },{
                        id: 4,
                        name:'设备数据',
                        path: '/admin/device',
                    }
                ],
                subMenu: [],
            }
        },
        created() {
            this.getCookie()
        },
        watch: {
            '$route': {
                handler(route){
                    // this.getCookie()
                    this.menuId = route.path.indexOf('index')>-1 ? 1:route.path.indexOf('xl')>-1 ? 2:route.path.indexOf('wl')>-1 ? 3:4
                    this.subMenuId = 1
                    let item = this.menuList.find(it => it.id == this.menuId)
                    this.subMenu = item && item.children ? item.children : []
                },
                immediate: true
            },
        },
        beforeDestroy(){
        },
        methods: {
            /** 退出登陆 */
            exitLogin() {
                sessionStorage.removeItem('username_2')
                this.$router.push('/login');
            },
            getCookie(){
                let cache = JSON.parse(sessionStorage.getItem('username_2'))
                this.userInfo = cache
                try {
                    if(cache){
                    }else{
                        alert('登录已过期，请重新登录')
                        this.$router.push('/login');
                    }
                } catch (e) {
                    console.log(e)
                    this.$message.error('用户非法进入页面');
                    this.$router.push('/login');
                    throw new Error('用户非法进入页面')
                }
            },
            clickMenu(val){
                this.menuId = val.id
                if(val.path){
                    this.$router.push(val.path)
                }
                if(val.children){
                    this.subMenu = val.children
                    this.subMenuId = this.subMenu[0].id
                    // let path = this.subMenu[0].path
                    // if(path){
                    //     this.$router.push(path)
                    // }
                }
            },
            clickSubMenu(val){
                this.subMenuId = val.id
            }
        }
    }
</script>

<style lang="less" scoped>
    @import '@/styles/common';
    @import '@/styles/layout/index2';
    .iframeContain{
        width: 100%;
        height: 100%;
        border: 0;
    }
    .popitem{
        cursor: pointer;
        display: block;
        color: #000;
        line-height: 1;
        padding: 10px 0;
        .link{
            color: #000;
        }
    }
</style>